/* eslint-disable @angular-eslint/directive-selector */
import { AfterViewInit, Directive, inject } from '@angular/core';
import { DatePicker } from 'primeng/datepicker';
import Inputmask from 'inputmask';

@Directive({ selector: '[cmg-date-mask]' })
export class CmgPrimeNgDatePickerMaskDirective implements AfterViewInit {
  private readonly _primeCalendar = inject(DatePicker);

  ngAfterViewInit() {
    new Inputmask(this.getDateMask()).mask(this.getHTMLInput());
  }

  getHTMLInput(): HTMLInputElement {
    if (this._primeCalendar) {
      return this._primeCalendar.el.nativeElement.querySelector('input');
    }
  }

  getDateMask(): string {
    if (this._primeCalendar && this._primeCalendar.timeOnly) {
      return '99:99';
    } else if (this._primeCalendar && this._primeCalendar.showTime) {
      return '99/99/9999 99:99';
    } else {
      return '99/99/9999';
    }
  }
}
